import { useState } from "react";
import { Link, router } from "@inertiajs/react";
import I from "../../components/Icons";
import { common, pick } from "../../lib/i18n";

interface Props {
  alert?: string;
  registration_open?: boolean;
}

const copy = {
  pl: { heading: "Zaloguj się", forgot: "Nie pamiętasz hasła?", submit: "Zaloguj się", noAccount: "Nie masz konta?", register: "Zarejestruj się" },
  en: { heading: "Sign in", forgot: "Forgot your password?", submit: "Sign in", noAccount: "No account?", register: "Sign up" },
};

export default function Login({ alert, registration_open = true }: Props) {
  const t = pick(copy);
  const c = common();
  const [form, setForm] = useState({ email: "", password: "" });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    router.post("/users/sign_in", { user: form });
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "var(--bg)", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 400 }}>
        <Link href="/" className="logo" style={{ display: "inline-flex", marginBottom: 32 }}>
          <span className="logo-mark" />
          <span>AvantoAI</span>
        </Link>

        <div className="panel">
          <div className="panel-hd"><h3>{t.heading}</h3></div>
          <div className="panel-body">
            {alert && (
              <div style={{ marginBottom: 14, padding: "8px 12px", background: "oklch(0.62 0.20 25 / 0.08)", border: "1px solid oklch(0.62 0.20 25 / 0.3)", borderRadius: "var(--radius)", fontSize: 12, color: "var(--danger)" }}>
                {alert}
              </div>
            )}

            <form onSubmit={submit}>
              <div className="field">
                <label>{c.auth.email}</label>
                <input className="input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required autoFocus />
              </div>
              <div className="field" style={{ marginBottom: 8 }}>
                <label>{c.auth.password}</label>
                <input className="input" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
              </div>
              <div style={{ textAlign: "right", marginBottom: 18 }}>
                <Link href="/users/password/new" style={{ fontSize: 12, color: "var(--muted)" }}>{t.forgot}</Link>
              </div>
              <button type="submit" className="btn btn-accent" style={{ width: "100%", justifyContent: "center", height: 36 }}>
                {I.spark} {t.submit}
              </button>
            </form>
          </div>
        </div>

        {registration_open && (
          <div style={{ textAlign: "center", marginTop: 16, fontSize: 12.5, color: "var(--muted)" }}>
            {t.noAccount} <Link href="/users/sign_up" style={{ color: "var(--ink)", fontWeight: 500 }}>{t.register}</Link>
          </div>
        )}
      </div>
    </div>
  );
}
